import { useState } from "react";
import { Loader2, Sparkles } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import api, { formatApiErrorDetail } from "@/lib/api";

const AdminAssistant = () => {
  const [insights, setInsights] = useState("");
  const [loading, setLoading] = useState(false);

  const analyze = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/admin/ai/insights");
      setInsights(data.insights);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <section data-testid="admin-assistant">
      <h1 className="font-display text-3xl font-semibold text-bark">Assistant IA</h1>
      <p className="mt-1 text-sm text-bark/50">
        L'assistant analyse vos commandes, paiements et avis des 30 derniers jours, puis vous suggère des actions concrètes pour développer la boutique.
      </p>

      <div className="mt-8 border border-clay bg-cream p-6">
        <button
          data-testid="admin-ai-insights-button"
          onClick={analyze}
          disabled={loading}
          className="flex h-11 items-center gap-2 rounded-full bg-terracotta px-6 text-xs font-bold uppercase tracking-[0.15em] text-sand transition-colors hover:bg-terracotta-dark disabled:opacity-50"
        >
          {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Sparkles className="h-4 w-4" />}
          {loading ? "Analyse en cours…" : "Analyser mes ventes"}
        </button>

        {insights && (
          <div data-testid="admin-ai-insights-output" className="mt-6 border border-clay bg-white p-6">
            <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-terracotta">Analyse des 30 derniers jours</p>
            <p className="mt-3 whitespace-pre-line text-sm leading-relaxed text-bark/80">{insights}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AdminAssistant;
